
import { defineComponent } from 'vue'
import AppointmentTypeService from '../common/appointmentTypeService'
import SponsorService from '../common/sponsorService'
import { AppointmentType } from '../models/appointmentType'
import { Sponsor, SponsorDetail } from '../models/sponsor'

export default defineComponent({
  name: 'Sponsors',

  data () {
    return {
      isActive: true,

      /** list of appointment types */
      appointmentTypes: [] as Array<AppointmentType>,

      /** indicates if should show sponsor form */
      shouldShowSponsorForm: false,

      /** list of sponsors */
      sponsors: [] as Array<SponsorDetail>,

      /** sponsor form */
      sponsorForm: null as unknown as Sponsor,

      /** filter key */
      filterKey: ''
    }
  },

  computed: {
    /** Is Editing sponsor form */
    isEditing: function (): boolean {
      return this.sponsorForm && (this.sponsorForm.id !== 0)
    },

    /** Is Valid sponsor form */
    isValid: function (): boolean {
      return this.sponsorForm.name !== null && this.sponsorForm.appointmentTypeId !== null
    },

    /** Filtered Sponsors list */
    filteredSponsors (): Array<SponsorDetail> {
      if (this.filterKey !== '') {
        return this.sponsors.filter(s => RegExp(this.filterKey, 'i').test(s.name))
      } else {
        return this.sponsors
      }
    }
  },

  mounted () {
    // load sponsors and appoitnment types
    this.getSponsors()
    this.getAppointmentTypes()
  },

  methods: {
    /**
     * Get Appointment Types
     */
    getAppointmentTypes () {
      AppointmentTypeService.getPublic().then(res => {
        this.appointmentTypes = res.data
      })
    },

    /**
     * Show Create Form
     */
    showCreateForm () {
      this.sponsorForm = {
        id: 0,
        name: '',
        appointmentTypeId: null as unknown as number,
        toTop: false
      } as Sponsor

      this.shouldShowSponsorForm = true
    },

    /**
     * Show Update Form
     */
    showUpdateForm (sponsor: SponsorDetail) {
      if (sponsor.appointmentType != null) {
        this.sponsorForm = {
          id: sponsor.id,
          name: sponsor.name,
          appointmentTypeId: sponsor.appointmentType.id,
          toTop: sponsor.toTop
        }
      } else {
        this.sponsorForm = {
          id: sponsor.id,
          name: sponsor.name,
          appointmentTypeId: null,
          toTop: sponsor.toTop
        }
      }

      this.shouldShowSponsorForm = true
    },

    /**
     * Get Sponsors
     */
    getSponsors () {
      SponsorService.getAllDetailed().then(res => {
        this.sponsors = res.data.sort((a, b) => {
          if (a.toTop > b.toTop) {
            return -1
          } else if (a.toTop < b.toTop) {
            return 1
          } else {
            return 0
          }
        })
      })
    },

    /**
     * Create Sponsor
     */
    createSponsor () {
      this.isActive = false
      SponsorService.create(this.sponsorForm).then(res => {
        this.sponsors.push(res.data)
        this.shouldShowSponsorForm = false
        this.isActive = true
      })
    },

    /**
     * Update Sponsor
     */
    updateSponsor () {
      this.isActive = false
      SponsorService.update(this.sponsorForm.id, this.sponsorForm).then(res => {
        const sponsor = this.sponsors.find(s => s.id === this.sponsorForm.id)
        if (sponsor) {
          sponsor.name = res.data.name
          sponsor.appointmentType = res.data.appointmentType
        }
        this.shouldShowSponsorForm = false
        this.isActive = true
      })
    },

    /**
     * Remove Sponsor
     */
    removeSponsor (id: number) {
      if (window.confirm('Are you sure you want to Remove?')) {
        SponsorService.remove(id).then(res => {
          const ind = this.sponsors.findIndex(s => s.id === id)
          if (ind !== -1) {
            this.sponsors.splice(ind, 1)
          }
        })
      }
    }
  }
})
